<template>
    <FormSelect
        v-model="value"
        :options="filteredOptions"
        :null-option="nullOption"
        :null-option-text="nullOptionText"
        :optgroups="optgroups"
    />
</template>

<script setup>
import { computed, watch } from 'vue';
import { useVModel } from '@vueuse/core';
import FormSelect from './FormSelect.vue';

const props = defineProps({
    modelValue: {
        required: true,
    },
    disabled: {
        required: false,
        type: Boolean,
        default: false,
    },
    options: {
        required: true,
        type: Array,
    },
    nullOption: {
        required: false,
        type: Boolean,
        default: true,
    },
    nullOptionText: {
        required: false,
        type: String,
        default: '',
    },
    propertyName: {
        required: false,
        type: String,
        default: 'text',
    },
    propertyValue: {
        required: false,
        type: String,
        default: 'value',
    },
    optgroups: {
        required: false,
        type: Boolean,
        default: false,
    },
    filterProperty: {
        required: true,
        type: String,
    },
    filterValue: {
        required: true,
        type: [Number, String, null],
    },
});
let emit = defineEmits(['update:modelValue']);
const value = useVModel(props, 'modelValue', emit);

watch(
    () => props.filterValue,
    () => {
        value.value = null;
    },
);

const filteredOptions = computed(() => {
    if (!props.filterValue) {
        return [];
    }

    return props.options.filter((option) => +option[props.filterProperty] === +props.filterValue);
});
</script>
